(function () {
  var blogPostCarouselObserverStarted = false;

  var initBlogPostCarousel = function ($carousel) {
    if ($carousel.hasClass('owl-loaded') || $carousel.data('owl.carousel')) {
      return true;
    }

    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.owlCarousel) {
      return false;
    }

    $carousel.owlCarousel({
      loop: true,
      margin: 10,
      autoplay: true,
      nav: true,
      autoplayTimeout: 3000,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 3
        }
      }
    });

    return true;
  };

  var initBlogPostCarousels = function () {
    if (!window.jQuery) return false;

    var $carouselWrapper = window.jQuery('.blog-post');

    if (!$carouselWrapper.length) return true;

    var $carousels = $carouselWrapper.find('.owl-carousel');

    if (!$carousels.length) return true;

    var initialized = true;

    $carousels.each(function () {
      if (!initBlogPostCarousel(window.jQuery(this))) {
        initialized = false;
      }
    });

    return initialized;
  };

  var observeBlogPostCarousels = function () {
    var carouselWrapper = document.querySelector('.blog-post');

    if (!carouselWrapper || !carouselWrapper.querySelector('.owl-carousel')) return;

    if (initBlogPostCarousels()) return;
    if (blogPostCarouselObserverStarted) return;

    blogPostCarouselObserverStarted = true;

    var fallbackInterval = null;
    var observer = new MutationObserver(function () {
      if (initBlogPostCarousels()) {
        if (fallbackInterval) {
          window.clearInterval(fallbackInterval);
        }

        blogPostCarouselObserverStarted = false;
        observer.disconnect();
      }
    });

    observer.observe(carouselWrapper, {
      childList: true,
      subtree: true
    });

    var attempts = 0;
    fallbackInterval = window.setInterval(function () {
      attempts += 1;

      if (initBlogPostCarousels() || attempts >= 10) {
        window.clearInterval(fallbackInterval);
        blogPostCarouselObserverStarted = false;
        observer.disconnect();
      }
    }, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBlogPostCarousels);
  } else {
    observeBlogPostCarousels();
  }

  window.addEventListener('load', observeBlogPostCarousels);
  document.addEventListener('shopify:section:load', observeBlogPostCarousels);
})();
